import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  key: 0,
  class: "rounded-lg border border-slate-200 bg-white p-4"
}
const _hoisted_3 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_4 = { class: "flex min-w-0 flex-col md:col-span-5 lg:col-span-4" }
const _hoisted_5 = { class: "flex min-w-0 flex-col md:col-span-3 lg:col-span-2" }
const _hoisted_6 = { class: "flex flex-wrap items-center justify-between gap-3" }
const _hoisted_7 = { class: "flex w-full flex-col gap-3" }
const _hoisted_8 = { class: "flex gap-3" }
const _hoisted_9 = { class: "relative flex flex-1" }
const _hoisted_10 = { class: "flex flex-wrap gap-2" }
const _hoisted_11 = { class: "flex flex-col gap-4" }
const _hoisted_12 = { class: "flex min-w-0 flex-col" }
const _hoisted_13 = { class: "flex min-w-0 flex-col" }
const _hoisted_14 = { class: "flex justify-end gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDeleteModal = _resolveComponent("ConfirmDeleteModal")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Danh sách dân cư trong tổ" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($setup.adminPermission)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_Dropdown, {
                    id: "civilGroup",
                    modelValue: $setup.idCivilGroupSelect,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.idCivilGroupSelect) = $event)),
                    options: $setup.listCivilGroupNew,
                    optionLabel: "civilGroupName",
                    optionValue: "id",
                    onChange: $setup.selectedCivilGroup,
                    placeholder: "Vui lòng chọn tổ...",
                    filter: true,
                    class: "w-full"
                  }, null, 8, ["modelValue", "options", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Button, {
                    label: "Tất cả công dân",
                    icon: "pi pi-list",
                    iconPos: "left",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.getAll()))
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_DataTable, {
          loading: _ctx.isLoading,
          value: $setup.listPeople,
          paginator: true,
          stripedRows: "",
          rows: 10,
          rowsPerPageOptions: [10, 25, 50],
          rowHover: true,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          filters: $setup.filters,
          "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => (($setup.filters) = $event)),
          globalFilterFields: ['fullName', 'phoneNumber'],
          currentPageReportTemplate: "Có tổng số {totalRecords} cư dân",
          resizableColumns: "",
          tableclass: "h-[60px]"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Button, {
                    type: "button",
                    icon: "pi pi-filter-slash",
                    label: "Xoá",
                    outlined: "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearFilter())),
                    class: "w-[6em]"
                  }),
                  _createElementVNode("span", _hoisted_9, [
                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400" }, null, -1)),
                    _createVNode(_component_InputText, {
                      class: "!w-[500px] !pl-10 !pr-3",
                      modelValue: $setup.filters['global'].value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters['global'].value) = $event)),
                      placeholder: "Tìm theo tên hoặc số điện thoại"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                (!$setup.adminPermission)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      type: "button",
                      icon: "pi pi-trash",
                      label: "Xoá đã chọn",
                      severity: "danger",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.deleteSelectedPeople())),
                      loading: $setup.deletingSelected,
                      disabled: $setup.selectedPeopleIds.length < 1,
                      class: "w-fit"
                    }, null, 8, ["loading", "disabled"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "",
              class: "h-[60px]"
            }, {
              header: _withCtx(() => [
                _createVNode(_component_Checkbox, {
                  modelValue: $setup.isAllSelected,
                  binary: true,
                  "onUpdate:modelValue": $setup.toggleSelectAll
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              body: _withCtx((slotProps) => [
                _createVNode(_component_Checkbox, {
                  modelValue: $setup.isSelected(slotProps.data),
                  binary: true,
                  "onUpdate:modelValue": ($event: any) => ($setup.toggleSelect(slotProps.data))
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "fullName",
              header: "Họ và tên",
              sortable: "",
              class: "h-[60px]"
            }),
            _createVNode(_component_Column, {
              field: "phoneNumber",
              header: "Số điện thoại",
              class: "h-[60px]",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "civilGroup",
              header: "Thôn/Tổ",
              class: "h-[60px]",
              sortable: ""
            }),
            (!$setup.adminPermission)
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 0,
                  header: "Thao tác",
                  class: "h-[60px]"
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_Button, {
                        severity: "info",
                        label: "Sửa",
                        icon: "pi pi-pencil",
                        onClick: ($event: any) => ($setup.openEditResident(slotProps.data)),
                        disabled: $setup.deletingId === $setup.getPersonId(slotProps.data),
                        class: "!min-h-[36px] px-3 py-1.5"
                      }, null, 8, ["onClick", "disabled"]),
                      _createVNode(_component_Button, {
                        severity: "danger",
                        label: "Xoá",
                        icon: "pi pi-trash",
                        onClick: ($event: any) => ($setup.deletePerson(slotProps.data)),
                        loading: $setup.deletingId === $setup.getPersonId(slotProps.data),
                        class: "!min-h-[36px] px-3 py-1.5"
                      }, null, 8, ["onClick", "loading"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "value", "filters"])
      ]),
      _createVNode(_component_Dialog, {
        visible: $setup.isEditDialogVisible,
        "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (($setup.isEditDialogVisible) = $event)),
        header: "Sửa thông tin dân cư",
        modal: "",
        style: { width: 'min(520px, calc(100vw - 32px))' }
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Button, {
              label: "Huỷ",
              icon: "pi pi-times",
              severity: "secondary",
              outlined: "",
              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.closeEditDialog())),
              disabled: $setup.isUpdating
            }, null, 8, ["disabled"]),
            _createVNode(_component_Button, {
              label: "Lưu",
              icon: "pi pi-check",
              onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.updateResident())),
              loading: $setup.isUpdating,
              disabled: !$setup.canUpdateResident
            }, null, 8, ["loading", "disabled"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { for: "editFullName" }, "Họ và tên", -1)),
              _createVNode(_component_InputText, {
                id: "editFullName",
                modelValue: $setup.editForm.fullName,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.editForm.fullName) = $event)),
                placeholder: "Nhập họ và tên"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { for: "editPhoneNumber" }, "Số điện thoại", -1)),
              _createVNode(_component_InputText, {
                id: "editPhoneNumber",
                modelValue: $setup.editForm.phoneNumber,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.editForm.phoneNumber) = $event)),
                placeholder: "Nhập số điện thoại",
                onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => ($setup.updateResident()), ["enter"]))
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_ConfirmDeleteModal, {
        modelValue: $setup.showConfirmModal,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.showConfirmModal) = $event)),
        title: $setup.confirmTitle,
        message: $setup.confirmMessage,
        "is-loading": $setup.isConfirming,
        onConfirm: $setup.confirmAction,
        onCancel: $setup.cancelAction
      }, null, 8, ["modelValue", "title", "message", "is-loading", "onConfirm", "onCancel"])
    ]),
    _: 1
  }))
}